import clsx from 'clsx'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import useAuth from '../../hooks/useAuth'
import useUser from '../../hooks/useUser'
import AppRoutes from '../../routes/appRoutes'
import L1NLogoWhiteStroke from '../../svg/L1N-logo-white-stroke.svg'
import LoginTransition from '../LoginPage/components/LoginTransition'
import ForgotPasswordForm from './components/ForgotPasswordForm'
import SuccessForgotPassword from './components/SuccessForgotPassword'

const ForgotPasswordPage = () => {
    const { handleForgotPassword } = useAuth()
    const { formIsLoading, formSuccess, formHasErrored, cleanForm } = useUser()

    useEffect(() => {
        return () => {
            cleanForm()
        }
    }, [])

    const processSubmit = values => {
        return handleForgotPassword(values?.email)
    }

    const renderHeader = () => {
        return (
            <section className="flex flex-col items-center justify-start w-full">
                <img className="h-8 w-28" src={L1NLogoWhiteStroke} />
                <h1 className="sm:text-3xl text-2.5xl mt-4 font-bold text-white">
                    Forgot Password
                </h1>
            </section>
        )
    }

    return (
        <LoginTransition>
            <div
                className={clsx(
                    'transition-all w-full h-full sm:p-16 p-6 flex flex-col items-center justify-between gap-y-6',
                    formSuccess && 'gap-y-18',
                )}
            >
                {renderHeader()}
                {formSuccess ? (
                    <SuccessForgotPassword />
                ) : (
                    <ForgotPasswordForm
                        onSubmit={processSubmit}
                        formIsLoading={formIsLoading}
                        formError={formHasErrored}
                    />
                )}
                <Link
                    to={AppRoutes.login()}
                    className="text-yellow underline font-normal text-base"
                >
                    Return to Sign In
                </Link>
            </div>
        </LoginTransition>
    )
}

export default ForgotPasswordPage
